import { ref, useContext, computed, useRoute } from '@nuxtjs/composition-api';

const useCertificates = () => {
  const {
    $api: { categoriesService, documentsService },
    $axios,
  } = useContext();
  const SKUData = ref([]);
  const certificatesBySKUData = ref({});
  const SKUCategories = ref([]);
  const isLoadingSKUTree = ref(false);
  const isLoadingDocuments = ref(false);
  const isLoadingCertificate = ref(false);
  const certificate = ref();
  const route = useRoute();

  const isLoading = computed(
    () =>
      isLoadingSKUTree.value ||
      isLoadingDocuments.value ||
      isLoadingCertificate.value
  );

  const mergeCertificatesIntoCategorySKU = () => {
    SKUCategories.value = SKUData.value
      .map((category) => {
        const skus = [];
        category.skus?.forEach((sku) => {
          if (certificatesBySKUData.value[sku]) {
            certificatesBySKUData.value[sku].forEach((d) => {
              skus.push(d);
            });
          }
        });

        return {
          ...category,
          skus,
        };
      })
      .filter((category) => category.skus.length > 0);
  };

  const fetchProductsSKUTree = async () => {
    isLoadingSKUTree.value = true;
    try {
      const { data: categoriesData } =
        await categoriesService.getCategoriesWithProductSkus();
      SKUData.value = categoriesData;
    } finally {
      isLoadingSKUTree.value = false;
    }
  };

  const fetchDocumentsByType = async (type) => {
    isLoadingDocuments.value = true;
    try {
      const { data: documentsData } =
        await documentsService.getDocumentsGroupedBySku({
          type,
        });
      certificatesBySKUData.value = documentsData;
    } finally {
      isLoadingDocuments.value = false;
    }
  };
  const fetchCertificate = async () => {
    const skuName = route.value.params.slug;
    try {
      const {
        data: { data },
      } = await $axios.get(`/api/documents/${skuName.toLowerCase()}`);
      certificate.value = data;
    } finally {
      isLoadingCertificate.value = true;
    }
  };
  return {
    SKUCategories,
    isLoading,
    certificate,
    mergeCertificatesIntoCategorySKU,
    fetchProductsSKUTree,
    fetchDocumentsByType,
    fetchCertificate,
  };
};

export default useCertificates;
